import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UpdateProfileCitizenshipRequest } from '../../api/update-profile-citizenship/updateProfileCitizenship.types';
import type { UseUpdateProfileCitizenshipResult } from './useUpdateProfileCitizenship.types';

import { updateProfileCitizenship } from '../../api/update-profile-citizenship/updateProfileCitizenship';

export function useUpdateProfileCitizenship(): UseUpdateProfileCitizenshipResult {
  const queryClient = useQueryClient();

  return useMutation<void, Error, UpdateProfileCitizenshipRequest>({
    mutationFn: updateProfileCitizenship,
    onSuccess: async (): Promise<void> => {
      await queryClient.invalidateQueries({ queryKey: ['client-profiles'] });
    },
  });
}
